import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './TicketsPage.scss';
import UIButton from '@/components/shared/UIButton';
import UIPageTitle from '@/components/shared/UIPageTitle';
import TicketsTransactionsSection from '@/components/dashboard/Tickets/TicketsTransactionsSection/TicketsTransactionsSection';

const STORAGE_KEYS = {
  SELECTED_PROPERTY: 'tickets_selected_property',
  SELECTED_TENANT: 'tickets_selected_tenant',
  SELECTED_STATUS: 'tickets_selected_status',
  SELECTED_CATEGORY: 'tickets_selected_category',
} as const;

const saveFiltersToStorage = (
  property: string,
  tenant: string,
  status: string,
  category: string,
) => {
  try {
    localStorage.setItem(STORAGE_KEYS.SELECTED_PROPERTY, property);
    localStorage.setItem(STORAGE_KEYS.SELECTED_TENANT, tenant);
    localStorage.setItem(STORAGE_KEYS.SELECTED_STATUS, status);
    localStorage.setItem(STORAGE_KEYS.SELECTED_CATEGORY, category);
  } catch (error) {
    console.warn('Failed to save filters to localStorage:', error);
  }
};

const loadFiltersFromStorage = () => {
  try {
    return {
      property:
        localStorage.getItem(STORAGE_KEYS.SELECTED_PROPERTY) || 'all-properties',
      tenant: localStorage.getItem(STORAGE_KEYS.SELECTED_TENANT) || 'all-tenants',
      status: localStorage.getItem(STORAGE_KEYS.SELECTED_STATUS) || 'all-statuses',
      category: localStorage.getItem(STORAGE_KEYS.SELECTED_CATEGORY) || 'all-categories',
    };
  } catch (error) {
    console.warn('Failed to load filters from localStorage:', error);
    return {
      property: 'all-properties',
      tenant: 'all-tenants',
      status: 'all-statuses',
      category: 'all-categories',
    };
  }
};

const BackToDashboardButton = () => {
  const navigate = useNavigate();
  return (
    <UIButton
      outline={true}
      variant="primary"
      size="medium"
      onClick={() => navigate('/dashboard')}
    >
      Back to Dashboard
    </UIButton>
  );
};

const TicketsPage = () => {
  const savedFilters = loadFiltersFromStorage();
  const [selectedProperty, setSelectedProperty] = useState(savedFilters.property);
  const [selectedTenant, setSelectedTenant] = useState(savedFilters.tenant);
  const [selectedStatus, setSelectedStatus] = useState(savedFilters.status);
  const [selectedCategory, setSelectedCategory] = useState(savedFilters.category);

  useEffect(() => {
    saveFiltersToStorage(selectedProperty, selectedTenant, selectedStatus, selectedCategory);
  }, [selectedProperty, selectedTenant, selectedStatus, selectedCategory]);

  const handlePropertyChange = (property: string) => {
    setSelectedProperty(property);
  };

  const handleTenantChange = (tenant: string) => {
    setSelectedTenant(tenant);
  };

  const handleStatusChange = (status: string) => {
    setSelectedStatus(status);
  };

  const handleCategoryChange = (category: string) => {
    setSelectedCategory(category);
  };

  return (
    <>
      <UIPageTitle
        title="Tickets"
        action={<BackToDashboardButton />}
      />

      <TicketsTransactionsSection
        selectedProperty={selectedProperty}
        selectedTenant={selectedTenant}
        selectedStatus={selectedStatus}
        selectedCategory={selectedCategory}
        onPropertyChange={handlePropertyChange}
        onTenantChange={handleTenantChange}
        onStatusChange={handleStatusChange}
        onCategoryChange={handleCategoryChange}
      />
    </>
  );
};

export default TicketsPage;
